import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  fixPivot(mainTex, 'jump/', JUMP_ANIMATION_DATA.frames);
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 */
export function addJumpAnimationsToSprite(sprite) {
  if (sprite.anims.exists('idle')) return;

  for (const key in JUMP_ANIMATION_DATA.animations) {
    const animationData = JUMP_ANIMATION_DATA.animations[key];
    const frames = [];
    animationData.frames.forEach(frameNum => frames.push({ frame: `jump/${frameNum.toString()}` }));
    sprite.anims.create(
      {
        defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
        frameRate: animationData.framerate ?? 24,
        key,
        frames
      }
    );
    if (animationData.next !== null && animationData.next !== undefined) {
      sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + key, () => {
        sprite.play(animationData.next);
      });
    }
  }
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

// this data comes from the original game; this is the CreateJs sprite sheet animation export
const JUMP_ANIMATION_DATA = {
  frames: [
    [0, 0, 128, 256, 0, -22, -5],
    [128, 0, 128, 256, 0, -22, -5],
    [256, 0, 128, 256, 0, -22, -5],
    [384, 0, 128, 256, 0, -22, -5],
    [512, 0, 128, 256, 0, -22, -5],
    [640, 0, 128, 256, 0, -22, -5],
    [768, 0, 128, 256, 0, -22, -5],
    [896, 0, 128, 256, 0, -22, -5],
    [1024, 0, 128, 256, 0, -22, -5],
    [1152, 0, 128, 256, 0, -22, -5],
    [1280, 0, 128, 256, 0, -22, -5],
    [1408, 0, 128, 256, 0, -22, -5],
    [1536, 0, 128, 256, 0, -22, -5],
    [1664, 0, 128, 256, 0, -22, -5],
    [1792, 0, 128, 256, 0, -22, -5],
    [0, 256, 128, 256, 0, -22, -5],
    [128, 256, 128, 256, 0, -22, -5],
    [256, 256, 128, 256, 0, -22, -5],
    [384, 256, 128, 256, 0, -22, -5],
    [512, 256, 128, 256, 0, -22, -5],
    [640, 256, 128, 256, 0, -22, -5],
    [768, 256, 128, 256, 0, -22, -5],
    [896, 256, 128, 256, 0, -22, -5],
    [1024, 256, 128, 256, 0, -22, -5],
    [1152, 256, 128, 256, 0, -22, -5],
    [1280, 256, 128, 256, 0, -22, -5],
    [1408, 256, 128, 256, 0, -22, -5],
    [1536, 256, 128, 256, 0, -22, -5],
    [1664, 256, 128, 256, 0, -22, -5],
    [1792, 256, 128, 256, 0, -22, -5],
    [0, 512, 128, 256, 0, -22, -5],
    [128, 512, 128, 256, 0, -22, -5],
    [256, 512, 128, 256, 0, -22, -5],
    [384, 512, 128, 256, 0, -22, -5],
    [512, 512, 128, 256, 0, -22, -5],
    [640, 512, 128, 256, 0, -22, -5]
  ],
  animations: {
    Land: {
      frames: [
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        30,
        33,
        29,
        34,
        35
      ]
    },
    Jump: { frames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,17, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35], next: 'Idle' },
    Idle: { frames: [0] }
  }
};